import React from 'react';

// SVG Icons as components
const FaFacebookF = () => (
  <svg fill="currentColor" viewBox="0 0 320 512" height="1em" width="1em">
    <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
  </svg>
);

const FaInstagram = () => (
  <svg fill="currentColor" viewBox="0 0 448 512" height="1em" width="1em">
    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
  </svg>
);

const FaYoutube = () => (
  <svg fill="currentColor" viewBox="0 0 576 512" height="1em" width="1em">
    <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
  </svg>
);

const FaMapMarkerAlt = () => (
  <svg fill="currentColor" viewBox="0 0 384 512" height="1em" width="1em">
    <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" />
  </svg>
);

const styles = {
  footer: {
    backgroundColor: '#f8f9fa',
    color: '#333333',
    padding: '60px 20px 0 20px',
    fontFamily: "'Inter', 'Segoe UI', 'Arial', sans-serif",
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  mainContent: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '50px',
    paddingBottom: '40px',
    borderBottom: '1px solid #e0e0e0',
  },
  branding: {
    maxWidth: '350px',
  },
  clinicName: {
    color: '#00ba76',
    fontSize: '1.8rem',
    fontWeight: '700',
    margin: '0 0 15px 0',
    letterSpacing: '-0.5px',
  },
  tagline: {
    color: '#666666',
    fontSize: '0.95rem',
    margin: '0 0 25px 0',
    lineHeight: '1.6',
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#555555',
    fontSize: '0.9rem',
  },
  contactIcon: {
    color: '#00ba76',
    fontSize: '1rem',
  },
  quickLinks: {
    minWidth: '200px',
  },
  connectWithUs: {
    minWidth: '200px',
  },
  sectionTitle: {
    color: '#1a1a1a',
    fontSize: '1.1rem',
    fontWeight: '600',
    margin: '0 0 20px 0',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  },
  linksList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  linkItem: {
    marginBottom: '0',
  },
  footerLink: {
    color: '#555555',
    textDecoration: 'none',
    fontSize: '0.95rem',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    display: 'inline-block',
    position: 'relative',
    cursor: 'pointer',
  },
  socialsContainer: {
    display: 'flex',
    gap: '12px',
    marginTop: '5px',
    flexWrap: 'wrap',
  },
  socialIcon: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    color: 'white',
    fontSize: '1.1rem',
    cursor: 'pointer',
  },
  facebookIcon: {
    backgroundColor: '#1877f2',
  },
  instagramIcon: {
    background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
  },
  youtubeIcon: {
    backgroundColor: '#ff0000',
  },
  bottomBar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '25px 0',
    flexWrap: 'wrap',
    gap: '20px',
  },
  copyright: {
    fontSize: '0.9rem',
    color: '#666666',
  },
  brandName: {
    color: '#00ba76',
    fontWeight: '600',
  },
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { text: 'Home', path: '/' },
    { text: 'About Us', path: '/about' },
    { text: 'Services', path: '/services' },
    { text: 'Contact', path: '/contact' },
  ];

  const handleNavigation = (path) => {
    window.location.href = path;
  };

  return (
    <>
      <style>
        {`
          .footer-link:hover {
            color: #00ba76;
            transform: translateX(5px);
          }
          
          .footer-link::before {
            content: '';
            position: absolute;
            width: 0;
            height: 2px;
            bottom: -3px;
            left: 0;
            background-color: #00ba76;
            transition: width 0.3s ease;
          }
          
          .footer-link:hover::before {
            width: 100%;
          }
          
          .social-icon {
            transition: all 0.3s ease;
          }
          
          .social-icon:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 16px rgba(0, 186, 118, 0.3);
          }
          
          @media (max-width: 768px) {
            .footer-bottom-bar {
              justify-content: center;
              text-align: center;
            }
          }
        `}
      </style>

      <footer style={styles.footer}>
        <div style={styles.container}>
          <div style={styles.mainContent}>
            {/* Left Column: Branding and Contact */}
            <div style={styles.branding}>
              <h2 style={styles.clinicName}>Dietitian Karpagam</h2>
              <p style={styles.tagline}>
                Your trusted partner in achieving optimal health through personalized nutrition and wellness guidance.
              </p>
              <div style={styles.contactInfo}>
                <div style={styles.contactItem}>
                  <FaMapMarkerAlt style={styles.contactIcon} />
                  <span>Thanjavur, Tamil Nadu</span>
                </div>
              </div>
            </div>

            {/* Middle Column: Quick Links */}
            <div style={styles.quickLinks}>
              <h3 style={styles.sectionTitle}>Quick Links</h3>
              <ul style={styles.linksList}>
                {quickLinks.map(({ text, path }) => (
                  <li key={text} style={styles.linkItem}>
                    <button 
                      onClick={() => handleNavigation(path)}
                      style={{
                        ...styles.footerLink,
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        font: 'inherit',
                        cursor: 'pointer'
                      }} 
                      className="footer-link"
                    >
                      {text}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Column: Connect With Us */}
            <div style={styles.connectWithUs}>
              <h3 style={styles.sectionTitle}>Connect With Us</h3>
              <p style={{...styles.tagline, margin: '0 0 15px 0'}}>
                Follow us on social media for health tips and updates
              </p>
              <div style={styles.socialsContainer}>
                <a 
                  href="https://www.facebook.com/people/Dietitian-Karpagam-Ramesh/61581800516960/#" 
                  style={{...styles.socialIcon, ...styles.facebookIcon}} 
                  className="social-icon" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a 
                  href="https://www.instagram.com/dietitiankarpagam?igsh=MXB0amp6dGUxMmJ2cA==" 
                  style={{...styles.socialIcon, ...styles.instagramIcon}} 
                  className="social-icon" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
                <a 
                  href="https://www.youtube.com/@dietitiankarpagam" 
                  style={{...styles.socialIcon, ...styles.youtubeIcon}} 
                  className="social-icon" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="YouTube"
                >
                  <FaYoutube />
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div style={styles.bottomBar} className="footer-bottom-bar">
            <div style={styles.copyright}>
              © {currentYear} <span style={styles.brandName}>Karps Wellness</span>. All rights reserved. Powered by <span style={styles.brandName}>Tech Vaseegrah</span>.
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
